import dayjs, { Dayjs } from "utils/dayjs"
import { Guid } from "@/types"

export interface IGetAssetAcqiusitionDTO {
    assetId: Guid
    totalAcquisitionProductionCosts?: number | null
    acquisitionDate?: string | null
}

export default class AssetAcquisition {
    assetId: Guid
    totalAcquisitionProductionCosts?: number
    acquisitionDate?: Dayjs

    constructor(dto: IGetAssetAcqiusitionDTO) {
        this.assetId = dto.assetId
        this.totalAcquisitionProductionCosts = typeof dto.totalAcquisitionProductionCosts === "number" ? dto.totalAcquisitionProductionCosts : undefined
        this.acquisitionDate = dto.acquisitionDate ? dayjs(dto.acquisitionDate) : undefined
    }
}
